module.exports = __webpack_public_path__ + "img/19_19.b036f9dc.png";